import { isIOS } from "utils";

const NATIVE_KEYS = {
  API_KEY: 85,
  APP_INFO: 6,
  CAMERA: 55,
  LOGOUT: 63,
  SHOW_LOADER: 45,
  REMOVE_LOADER: 46,
  SHARE_VIA_WHATSAPP: 42,
  SHARE_GLOBALLY: 44,
  OPEN_URL: 8,
  OPEN_SCANNER: isIOS ? 14 : 49,
  BIOMETRIC: 20,
  OPEN_DEEPLINK_WITHOUT_CALLBACK: 2,
  OPEN_DEEPLINK_WITH_CALLBACK: 24,
  BACK_SUBSCRIPTION: 30,
  GET_CONTACTS: 16,
  CHECK_PERMISSIONS_STATUS: 553,
  REQUEST_PERMISSIONS: 52,
  OPEN_SETTINGS: 69,
  OPEN_SECURITY_SETTINGS: 67,
  SHARE_BASE64: 15,
};
export default NATIVE_KEYS;
